import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useFormContext } from "react-hook-form";
import { isMinimumAgeReached } from "../../BirthDateFormInputs";
import { DAY_INPUT_MAX_LENGTH, DayInput } from "../DayInput/DayInput";
import { MONTH_INPUT_MAX_LENGTH, MonthInput } from "../MonthInput/MonthInput";
import { YEAR_INPUT_MAX_LENGTH, YearInput } from "../YearInput/YearInput";
const reverseOrderByFormat = (format, orders) => {
    if (format === "yyyy/mm/dd") {
        return orders.slice().reverse();
    }
    return orders;
};
export const BirthDateInputs = ({ dayPlaceholder, monthPlaceholder, yearPlaceholder, minimumAge, format, }) => {
    const dayInputRef = useRef(null);
    const monthInputRef = useRef(null);
    const yearInputRef = useRef(null);
    const { watch, setError, clearErrors, formState } = useFormContext();
    watch((values) => {
        const year = Number(values?.year);
        const month = Number(values?.month);
        const day = Number(values?.day);
        if (day && month && year && !isMinimumAgeReached({ year, month, day, minimumAge })) {
            setError("minimumAge", {});
        }
        else if (formState.errors.minimumAge) {
            clearErrors("minimumAge");
        }
    });
    const handleKeyUp = (e) => {
        const orderOfInputs = reverseOrderByFormat(format, [
            { element: dayInputRef.current, maxLength: DAY_INPUT_MAX_LENGTH },
            { element: monthInputRef.current, maxLength: MONTH_INPUT_MAX_LENGTH },
            { element: yearInputRef.current, maxLength: YEAR_INPUT_MAX_LENGTH },
        ]);
        const currentInputElementIndex = orderOfInputs.findIndex((el) => el.element === e.currentTarget);
        const currentInputElement = orderOfInputs[currentInputElementIndex];
        if (currentInputElement.maxLength === e.currentTarget.value.length) {
            const nextElement = orderOfInputs[Math.min(currentInputElementIndex + 1, orderOfInputs.length - 1)];
            if (nextElement) {
                nextElement.element?.focus();
            }
        }
        if (e.key === "Backspace" && e.currentTarget.value.length === 0) {
            const prevElement = orderOfInputs[Math.max(currentInputElementIndex - 1, 0)];
            prevElement?.element?.focus();
        }
    };
    const inputs = [
        _jsx(DayInput, { placeholder: dayPlaceholder, onKeyUp: handleKeyUp, ref: dayInputRef, type: "textInput" }, "day"),
        _jsx(MonthInput, { placeholder: monthPlaceholder, onKeyUp: handleKeyUp, ref: monthInputRef, type: "textInput" }, "month"),
        _jsx(YearInput, { minimumAge: minimumAge, placeholder: yearPlaceholder, onKeyUp: handleKeyUp, ref: yearInputRef, type: "textInput" }, "year"),
    ];
    if (format === "yyyy/mm/dd") {
        return inputs.slice().reverse();
    }
    return inputs;
};
//# sourceMappingURL=BirthDateInputs.js.map